import { createSelector } from '@reduxjs/toolkit';
import { rolesAdapterSelectors } from '../redux/slices/roles';

const getUserFromStore = (state) => state.user;

const hasBrowserToken = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return !!window.localStorage.getItem('token');
  } catch (_error) {
    return false;
  }
};

export const isAuth = () =>
  createSelector(getUserFromStore, (user) => !!user && hasBrowserToken());

export const getUser = () =>
  createSelector(
    getUserFromStore,
    rolesAdapterSelectors.selectAll,
    (user, roles) => {
      if (!user) return null;
      return {
        ...user,
        userRoles: roles,
      };
    }
  );

export const getUserId = () =>
  createSelector(getUserFromStore, (user) => user.id || null);

export const getUserProfilePicture = () =>
  createSelector(getUserFromStore, (user) => user.profilePicture || null);

// UI hint only. The real gate is the server: every cross-workspace read goes
// through getAllWorkspaces, which requires workspace.view at system scope.
export const isSuperAdmin = () =>
  createSelector(getUserFromStore, (user) => !!user?.superAdmin);

export default null;
